import { Box, IconButton, SvgIcon } from '@material-ui/core';
import { onCloseMenu } from '@src/actions/mainmenu';
import { MINIMUM_HEADER_WIDTH } from '@src/components/AgentConsole/Layout/Utils';
import B2ChatLogoSvg from '@src/components/AdminHome/Common/SideNav/B2ChatLogoSvg';
import { useB2ChatLogo } from '@src/reducers/partnerCustomUiApi';
import type { RootState } from '@src/store/reduxstore';
import { useDispatch, useSelector } from 'react-redux';
import Trial from '../Trial';
import HeaderMenu, { IHeaderAdmin } from './HeaderMenu';
import { MenuIcon } from './SvgIcons';

export interface HeaderProps {
  menuClose: boolean;
  handleCloseMenu: () => void;
  logoUrl?: string;
  isDefaultLogo?: boolean;
  consoleHeader?: boolean;
  tight?: boolean;
}

const HeaderWrapper: React.FC<IHeaderAdmin> = ({ consoleHeader = false }) => {
  const menu: { close?: boolean } = useSelector(
    ({ adminHome }: RootState) => adminHome.menu
  );
  const dispatch = useDispatch();

  const { logoUrl, isDefault } = useB2ChatLogo();

  const handleCloseMenu = () => dispatch(onCloseMenu());

  return (
    <Header
      menuClose={!!menu.close}
      handleCloseMenu={handleCloseMenu}
      logoUrl={logoUrl}
      isDefaultLogo={isDefault}
      consoleHeader={consoleHeader}
    />
  );
};

export const Header: React.FC<HeaderProps> = ({
  menuClose,
  handleCloseMenu,
  logoUrl,
  isDefaultLogo,
  consoleHeader,
  tight,
}) => (
  <>
    <Box display="flex" maxWidth={tight ? MINIMUM_HEADER_WIDTH : '100%'}>
      {menuClose && !consoleHeader && (
        <Box display="flex" alignItems="center" pr={3}>
          <IconButton
            onClick={handleCloseMenu}
            style={{ paddingLeft: 0, marginRight: 10 }}
          >
            <SvgIcon>{MenuIcon}</SvgIcon>
          </IconButton>
          {isDefaultLogo ? (
            <B2ChatLogoSvg />
          ) : (
            <img src={logoUrl} alt="" style={{ height: 32 }} />
          )}
        </Box>
      )}

      <Box ml="auto" width="100%">
        <HeaderMenu consoleHeader={consoleHeader} tight={tight} />
      </Box>
    </Box>

    <Trial />
  </>
);

export default HeaderWrapper;
